import { useState } from 'react'

export const useDialog = () => {
  const [openDialog, setOpenDialog] = useState(false)
  const [title, setTitle] = useState('')

  const handleOpenDialog = (): void => setOpenDialog(true)

  const handleCloseDialog = (): void => setOpenDialog(false)

  const handleChangeTitle = (text: string): void => setTitle(text)

  return { openDialog, handleOpenDialog, handleCloseDialog, title, handleChangeTitle }
}
